<template>
  <div>
         <modal-devices 
                :showDialog = "showDialog" 
                :devices= "modules" @close="showDialog = false" 
                @addDevice="addDevice"
                section="products"
                :deviceTypes="['module']"
                >
         </modal-devices>
    <v-row>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.dcPower"
          label="Potência DC (kWp)"
          v-bind:options="$globalFunctions.optionsDecimal"
        />
      </v-col>
            <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.dcPowerWpModule"
          label="Potência do Módulo (kWp)"
          v-bind:options="$globalFunctions.optionsDecimal"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.acVoltage"
          :items="voltageOptions"
          label="Tensão AC (V)"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          class="my-5"
          v-model="device.acPhases"
          :items="phasesOptions"
          label="Fases"
          item-text="text"
          item-value="value"
          dense
        >
        </v-select>
      </v-col>
     
     
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.efficiency"
          label="Eficiência (%)"
          v-bind:options="$globalFunctions.optionsMoneyBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.weight"
          label="Peso (kg)"
          v-bind:options="$globalFunctions.optionsMoneyBr"
        />
      </v-col>
      <!-- <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.height"
          label="Altura (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.width"
          label="Largura (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.depth"
          label="Profundidade (mm)"
          v-bind:options="optionsInteger"
        />
      </v-col> -->
       <v-col cols="12" md="5">
            <v-select
              class="my-5"
              @change="structureChanged"
              v-model="device.structureId"
              :items="structureOptions"
              label="Estrutura"
              item-text="text"
              item-value="value"
              dense
            >
            </v-select>
          </v-col>


      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.warranty"
          label="Garantia (anos)"
          v-bind:options="$globalFunctions.optionsInteger"
        />
      </v-col>
    </v-row>
    <v-card>
      <v-toolbar class="primary" dark>
        <p>Módulos</p>
        <v-spacer></v-spacer>
        <v-btn class="secondary" @click="showDialog =true;">+</v-btn>
 
      </v-toolbar>
  

    <v-row class="ma-4"   v-for="(m, index) in device.modules" :key = "index" >
      <v-col md="1" sm="12">
        <v-btn @click="deleteModule(index)"  class="secondary">
          <v-icon >mdi-delete</v-icon>
        </v-btn>
      </v-col>
      
      <v-col md="3" sm="12">
          <v-select
            class="my-5"
            v-model="m.id"
            :items="moduleOptions"
            label="Módulo"
            item-text="text"
            item-value="value"
            dense
          >
          </v-select>
         </v-col>

         <v-col md="4"  sm="12">
          <v-text-field label= "Descrição" v-model = "m.description">
          </v-text-field>
        </v-col>
    

        <v-col md="2"  sm="12">
          <v-text-field label= "Fabricante" v-model = "m.manufacturer">
          </v-text-field>
        </v-col>
    

        <v-col md="2"  sm="12">
          <v-text-field label= "Quantidade" v-model.number = "m.quantity" @change="updateDcPower">
          </v-text-field>
        </v-col>
    
    </v-row>
    </v-card>
    
  </div>
</template>



<script>
import hebelApi from '../../../../libraries/hebel/hebelApi';

import ModalDevices from "../../components/modals/ModalDevices"
export default {
  components: {
    // EditModulo
    ModalDevices
  },

  name: "edit-generator",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      voltageOptions: [
        { value: 220, text: "220V" },
        { value: 380, text: "380V" },
      ],
      phasesOptions: [
        { value: 1, text: "Monofásico" },
        { value: 3, text: "Trifásico" },
      ],
    structures:[],
    structureOptions:[],
    moduleOptions:[],
    modules:[],
    showDialog:false,
      
    };
  },

   async mounted() {

    // this.structures = await this.$dao.getDevices(
    //   window.eid,
    //   "*",
    //   "structure",
    //   true
    // );
    this.structures = await hebelApi.devices.getAll('*','structure',true);

    for (var s = 0; s < this.structures.length; s++) {
      this.structureOptions.push({
        value: this.structures[s].id,
        text: `  (${this.structures[s].manufacturer})  ${this.structures[s].structureType}`,
      });
    }

     //this.modules = await this.$dao.getAllModules(window.eid);
      this.modules = await hebelApi.devices.getAllModules();

      for (var a = 0; a < this.modules.length; a++) {
        this.moduleOptions.push({
          value: this.modules[a].id,
          text: `(${this.modules[a].manufacturer}) ${this.modules[a].code} `,
        });
      }


      if(!this.device.id){
         var structureId = this.$session.get("structureId");
          if(structureId)
            this.device.structureId = structureId;

      }
    
    },

  methods: {
    structureChanged(){
        //alert("Structure changed")
    },
    deleteModule(index){
      //alert(`delete ${index}`)
      this.device.modules.splice(index,1);
      this.$forceUpdate();
      this.updateDcPower();
    },
    updateDcPower(){
      var dcPower = 0 ;
      var nModules = 0 ; 

      for (var m = 0 ; m < this.device.modules.length ; m++){
          dcPower +=  this.device.modules[m].quantity  *   this.device.modules[m].dcPower;
          nModules += this.device.modules[m].quantity;
      }
      this.device.dcPower = dcPower;
     // this.$emit("dcPowerChanged", dcPower);  
      this.device.code = `KIT-${this.$globalFunctions.formatDecimal( dcPower)}-KWP`
      this.device.description = `Kit gerador fotovoltaico ${ this.$globalFunctions.formatDecimal( dcPower)} kWp`
      
      this.device.nModules = nModules;
      //alert(this.device.code);

    },
    addDevice(m,section){
        if(!this.device.modules)
          this.device.modules = [];

        m.quantity = 1;
        this.device.modules.push(m);
        this.updateDcPower();
       this.$forceUpdate();
        this.showDialog = false;
    }
  },
   
    
};
</script>
